import { getterTypes } from './types';

const getters = {
  [getterTypes.GET_CATEGORIES]: (state) => state.categories,
  [getterTypes.GET_RESULTS]: (state) => state.results,
  [getterTypes.GET_PAGINATION]: (state) => state.pagination,
  [getterTypes.GET_FILTER]: (state) => state.filter,
};

export default getters;
